import { Dropdown, Menu } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import AuthStore from "../../../stores/AuthStore";
import styles from "./index.module.scss";
import { useNavigate } from "react-router";
import { joinClassNames } from "../../../utils";

const PageHeader1: React.FC = (props) => {
  const { account, orAdmin } = AuthStore;
  const navigate = useNavigate();
  return (
    <div className={styles.page_header}>
      统一登录
      <section className={styles.nav_container}>
        <div className={styles.Homeimg} />
      </section>
      <div className={styles.control}>
        {/* {account === "admin" && ( */}
          <span
            style={{display: Boolean(parseInt(orAdmin as string)) ? "inline-block" : "none" }}
            className={styles.admin}
            onClick={() => {
              navigate("/admin/projects");
            }}
          >
            后台管理
          </span>
        {/* )} */}
        <Dropdown
          overlay={
            <Menu
              onClick={(e) => {
                if (e.key === "logout") {
                  AuthStore.logout();
                }
              }}
              items={[{ label: "退出", key: "logout" }]}
            />
          }
        >
          <span className={styles.user_info}>{account}</span>
        </Dropdown>
      </div>
    </div>
    //   <section className={styles.menu_container}>
    //   {/* <button className={styles.menu_btn} style={{ marginRight: 12 }}>
    //     购买
    //   </button> */}

    //   {isLogin || (
    //     <span
    //       className={styles.menu_item}
    //       onClick={() => navigate("/auth/login")}
    //     >
    //       登录/注册
    //     </span>
    //   )}

    //   {isLogin && (
    //     <span
    //       className={styles.menu_item}
    //       onClick={() => navigate("/mine")}
    //     >
    //       我的
    //     </span>
    //   )}

    //   {isLogin && (
    //     <span
    //       className={styles.menu_item}
    //       onClick={() => AuthStore.logout()}
    //     >
    //       登出
    //     </span>
    //   )}
    // </section>
  );
};

export default observer(PageHeader1);
